// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"163":"MobileAppPage","383":"SalePage"}[chunkId] || chunkId) + "." + {"163":"7574ac77","212":"ce58f9f5","383":"7f4f5015"}[chunkId] + ".js";
};